module.exports = __webpack_public_path__ + "static/media/check-square-regular~bfuEdNti.1f021412.svg";